<template>
  <NuxtLink :to="courseUrl" class="course-card">
    <div v-if="course.imageUrl" class="course-image">
      <img
        :src="course.imageUrl"
        :alt="course.title"
        width="360"
        height="240"
        loading="lazy"
        decoding="async"
      >
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Course } from '@/domain/entities/course.entity'
import { useIndexRoutes } from '@/composables/locale/useIndexRoutes'

const { t } = useI18n()
const { buildPath, DEFAULT_CATEGORY } = useIndexRoutes()
const props = defineProps<{
  course: Course
  locale: string
  category?: string
}>()

const courseUrl = computed(() =>
  buildPath({
    locale: props.locale,
    category: props.category ?? props.course.category ?? DEFAULT_CATEGORY,
    slug: props.course.slug,
  }),
)
</script>

<style scoped>
.course-card {
  display: block;
  position: relative;
  width: 100%;
  min-width: 0;
  aspect-ratio: 311.03 / 455.9;
  border-radius: 12px;
  overflow: hidden;
  text-decoration: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background-color: #000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.course-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.course-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.course-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 0.3s ease;
}

.course-card:hover .course-image img {
  transform: scale(1.1);
}
</style>
